// src/components/NotFound.js

import React from 'react';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet"; // Importa React Helmet
import "../styles/NotFoundPage.css";
import image from "../images/404.png";
import Space from "../commons/Space";

function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="not-found">
            <Helmet>
                <title>404 - Pagina Non Trovata</title> {/* Imposta il titolo della pagina */}
                <meta name="robots" content="noindex, nofollow" /> {/* Impedisce l'indicizzazione */}
            </Helmet>
            <img
                src={image}
                alt="404 Not Found"
                className="not-found-image"
            />
            <h1>Oops! Qualcosa è andato storto...</h1>
            <p>Non siamo riusciti a trovare la pagina che stavi cercando.</p>
            <Space />
            <button
                style={{ maxWidth: "40em", minWidth: "10em", height: "3.5em", borderRadius: "1em", color: "white", backgroundColor: "#2F719D" }}
                type="button" className="btn"
                onClick={() => navigate("/")}
            >
                <h4>Torna alla home</h4>
            </button>
        </div>
    );
}

export default NotFound;
